// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { DomainRepoService } from '@client/app/services/api/domain-repo/domain-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ToastService } from '@monsido/angular-shared-components';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { PAGE_CORRECT_DOMAIN_SETTINGS_MODULE } from '@monsido/ng2/modules/page-fix/constants/domain-settings-modules.constant';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'page-fix-form-domain-settings',
    standalone: false,
    template: `
        <form class="form-horizontal" name="form" (ngSubmit)="form.valid && submit()" novalidate #form="ngForm">
            <div class="mon-dialog-header">
                <div class="mt-8">
                    <page-header [header]="'PageCorrect settings' | translate">
                    </page-header>
                </div>
            </div>
            <div class="mon-dialog-body-with-footer">
                <div class="card panel-monsido-card my-6 mx-6">
                    <div class="card-header">
                        <div class="row mt-3">
                            <div class="col-sm-10 text-right">
                                <label for="page_correct_admin_only" class="col-form-label text-bold" translate>
                                    Admin only
                                </label>
                                <span class="fas fa-info-circle"
                                      ngbTooltip="{{ 'Should admin be the only one to set PageCorrect Settings' | translate }}"
                                      [container]="'body'"
                                      [placement]="'top-right'">
                                </span>
                            </div>
                            <div class="col-sm-38">
                                <form-field-material-switch name="page_correct_admin_only" [(ngModel)]="settings.admin_only">
                                </form-field-material-switch>
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-3">
                        <p class="mt-0 text-grey" translate>
                            Enable PageCorrect features below. Disabled features will not be shown on your dashboard.
                        </p>
                        <div class="row mt-3">
                            <div class="col-sm-10 text-right">
                                <label for="page_correct_spelling_error" class="col-form-label text-bold" translate>
                                    Spelling
                                </label>
                                <span class="fas fa-info-circle"
                                      ngbTooltip="{{ 'Enable PageCorrect for Misspellings' | translate }}"
                                      [container]="'body'"
                                      [placement]="'top-right'"
                                      aria-hidden="true">
                                </span>
                            </div>
                            <div class="col-sm-38">
                                <form-field-material-switch name="page_correct_spelling_error"
                                                            [(ngModel)]="settings.checks.spelling.value"
                                                            (ngModelChange)="updateValid()">
                                </form-field-material-switch>
                            </div>
                        </div>
                        <div class="row mt-3" *ngIf="'accessibility' | domainActiveFeature:domain">
                            <div class="col-sm-10 text-right">
                                <label for="page_correct_accessibility_source_code" class="col-form-label text-bold" translate>
                                    Accessibility Source Code
                                </label>
                                <span class="fas fa-info-circle"
                                      ngbTooltip="{{ 'Enable PageCorrect for Accessibility Source Codes' | translate }}"
                                      [container]="'body'"
                                      [placement]="'top-right'"
                                      aria-hidden="true">
                                </span>
                            </div>
                            <div class="col-sm-38">
                                <form-field-material-switch name="page_correct_accessibility_source_code"
                                                            [(ngModel)]="settings.checks.accessibility_source_code.value"
                                                            (ngModelChange)="updateValid()">
                                </form-field-material-switch>
                            </div>
                        </div>
                        <div class="row mt-3" *ngIf="'accessibility' | domainActiveFeature:domain">
                            <div class="col-sm-10 text-right">
                                <label for="page_correct_accessibility_check" class="col-form-label text-bold" translate>
                                    Accessibility Check
                                </label>
                                <span class="fas fa-info-circle"
                                      ngbTooltip="{{ 'Enable PagedCorrect for Accessibility Checks' | translate }}"
                                      [container]="'body'"
                                      [placement]="'top-right'"
                                      aria-hidden="true">
                                </span>
                            </div>
                            <div class="col-sm-38">
                                <form-field-material-switch name="page_correct_accessibility_check"
                                                            [(ngModel)]="settings.checks.accessibility_check.value"
                                                            (ngModelChange)="updateValid()">
                                </form-field-material-switch>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-10 text-right">
                                <label for="page_correct_link" class="col-form-label text-bold" translate>Links</label>
                                <span class="fas fa-info-circle"
                                      ngbTooltip="{{ 'Enable PageCorrect for Broken Links' | translate }}"
                                      [container]="'body'"
                                      [placement]="'top-right'"
                                      aria-hidden="true">
                                </span>
                            </div>
                            <div class="col-sm-38">
                                <form-field-material-switch name="page_correct_link"
                                                            [(ngModel)]="settings.checks.link.value"
                                                            (ngModelChange)="updateValid()">
                                </form-field-material-switch>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-10 text-right">
                                <label for="page_correct_custom" class="col-form-label text-bold" translate>Custom</label>
                                <span class="fas fa-info-circle"
                                      ngbTooltip="{{ 'Enable Custom PageCorrect Settings' | translate }}"
                                      [container]="'body'"
                                      [placement]="'top-right'"
                                      aria-hidden="true">
                                </span>
                            </div>
                            <div class="col-sm-38">
                                <form-field-material-switch name="page_correct_custom"
                                                            [(ngModel)]="settings.checks.custom.value"
                                                            (ngModelChange)="updateValid()">
                                </form-field-material-switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mon-dialog-footer text-right">
                <button [disabled]="!isValid || form.invalid || saving" type="submit" class="btn btn-border-radius btn-secondary">
                    <span *ngIf="!saving">{{ saveToAPI ? ('Save' | translate) : ('Ok' | translate) }}</span>
                    <span class="fas fa-spinner fa-spin fa-lg" [hidden]="!saving"></span>
                </button>
            </div>
        </form>
    `,
})
export class PageFixFormDomainSettingsComponent implements OnInit {
    @Input() domain: any;
    @Input() saveToAPI: any;
    @Input() monDialogId: string = '';

    settings: any;
    saving = false;
    isValid = true;

    constructor (
        private monDialog: MonDialog,
        private domainRepoService: DomainRepoService,
        private translateService: TranslateService,
        private toastService: ToastService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.settings = {
            admin_only: !!this.domain.settings.scripts.page_correct.admin_only,
            checks: {
                spelling: {
                    name: 'SPELLING_ERROR',
                    value: this.domain.settings.scripts.page_correct.enabled_checks.some((check: string) => {
                        return PAGE_CORRECT_DOMAIN_SETTINGS_MODULE.SPELLING_ERROR === check;
                    }),
                },
                accessibility_source_code: {
                    name: 'ACCESSIBILITY_SOURCE_CODE',
                    value: this.domain.settings.scripts.page_correct.enabled_checks.some((check: string) => {
                        return PAGE_CORRECT_DOMAIN_SETTINGS_MODULE.ACCESSIBILITY_SOURCE_CODE === check;
                    }),
                },
                accessibility_check: {
                    name: 'ACCESSIBILITY_CHECK',
                    value: this.domain.settings.scripts.page_correct.enabled_checks.some((check: string) => {
                        return PAGE_CORRECT_DOMAIN_SETTINGS_MODULE.ACCESSIBILITY_CHECK === check;
                    }),
                },
                link: {
                    name: 'LINK',
                    value: this.domain.settings.scripts.page_correct.enabled_checks.some((check: string) => {
                        return PAGE_CORRECT_DOMAIN_SETTINGS_MODULE.LINK === check;
                    }),
                },
                custom: {
                    name: 'CUSTOM',
                    value: this.domain.settings.scripts.page_correct.enabled_checks.some((check: string) => {
                        return PAGE_CORRECT_DOMAIN_SETTINGS_MODULE.CUSTOM === check;
                    }),
                },
            },
        };
        this.saving = false;
        this.isValid = true;
    }

    submit (): void {
        this.saving = true;
        const checks = Object.keys(this.settings.checks)
            .map((checkKey) => {
                const check = this.settings.checks[checkKey];
                if (check.value) {
                    return (PAGE_CORRECT_DOMAIN_SETTINGS_MODULE as any)[check.name];
                }
            })
            .filter(Boolean);

        const pageCorrectSettings = {
            admin_only: this.settings.admin_only,
            enabled_checks: checks,
        };

        if (this.saveToAPI) {
            this.domainRepoService
                .update(this.domain.id, {
                    settings: {
                        scripts: {
                            page_correct: pageCorrectSettings,
                        },
                    },
                } as any)
                .then(() => {
                    this.toastService.success(this.translateService.getString('PageCorrect Settings Updated'));
                    const updatedPageCorrectSettings = safeClone(this.domain.settings.scripts.page_correct);
                    updatedPageCorrectSettings.admin_only = this.settings.admin_only;
                    updatedPageCorrectSettings.enabled_checks = checks;
                    this.close(updatedPageCorrectSettings);
                }, () => {})
                .finally(() => {
                    this.saving = false;
                });
        } else {
            this.close(pageCorrectSettings);
        }
    }

    updateValid (): void {
        setTimeout(() => {
            this.isValid = Object.keys(this.settings.checks).some((checkKey) => {
                const check = this.settings.checks[checkKey];
                return check.value;
            });
        });
    }

    private close (settings?: any): void {
        this.monDialog.close(this.monDialogId, settings);
    }
}
